module.exports = __webpack_public_path__ + "img/L1_open.78c4d60f.svg";